import { render, staticRenderFns } from "./GoAgency.vue?vue&type=template&id=36b5796c&scoped=true&"
import script from "./GoAgency.vue?vue&type=script&lang=js&"
export * from "./GoAgency.vue?vue&type=script&lang=js&"
import style0 from "./GoAgency.vue?vue&type=style&index=0&id=36b5796c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b5796c",
  null
  
)

export default component.exports